import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAgencyUser } from 'redux/selectors';
import { StaticTextRow, EmailStaticTextRow, SectionHeader } from 'components';
import styles from './form.module.css';

const BasicInfo = () => {
	const { swId, managerId, adminId } = useParams();
	const [userId, setUserId] = useState();

	useEffect(() => {
		setId();
	}, [swId, managerId, adminId]);

	const setId = () => {
		if (swId) {
			setUserId(swId);
		}
		if (managerId) {
			setUserId(managerId);
		}
		if (adminId) {
			setUserId(adminId);
		}
	};

	const { firstname, lastname, email, status, branch } = useSelector(
		getAgencyUser(userId)
	);
	const branchName = branch?.name ? branch.name : null;

	const inputs = [
		{ label: 'First Name', value: firstname },
		{ label: 'Last Name', value: lastname },
		{ label: 'Branch', value: branchName },
	];
	const inputMap = inputs?.map((val) => {
		return val.value ? (
			<StaticTextRow key={val.label} variant='outlined' {...val} />
		) : null;
	});

	return (
		<>
			<SectionHeader>Social-Worker Information</SectionHeader>
			<div className={styles.socialWorkerBasicInfoRoot}>
				{inputMap}
				<EmailStaticTextRow value={email} status={status} />
			</div>
		</>
	);
};

export default BasicInfo;
